(() => {
  const initHatSelector = (scope = document) => {
    if (document.querySelector('.ikon-builder-page')) {
      document.body.classList.add('ikon-builder-template');
    }

    scope.querySelectorAll('[data-ikon-hat-selector]').forEach((selector) => {
      if (selector.dataset.ikonInitialized === 'true') return;
      selector.dataset.ikonInitialized = 'true';

      const toggle = selector.querySelector('[data-ikon-filter-toggle]');
      const panel = selector.querySelector('[data-ikon-filter-panel]');

      if (toggle && panel) {
        toggle.addEventListener('click', () => {
          const isOpen = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
          const indicator = toggle.querySelector('[aria-hidden="true"]');
          if (indicator) indicator.textContent = isOpen ? '−' : '+';
        });
      }

      selector.querySelectorAll('[data-ikon-auto-submit]').forEach((select) => {
        select.addEventListener('change', () => select.form?.submit());
      });
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHatSelector());
  } else {
    initHatSelector();
  }

  document.addEventListener('shopify:section:load', (event) => initHatSelector(event.target));
})();
